import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QAResultEntity from "../../../../domain/entities/qa_result.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QAResultDto from "../../../dto/qa_result.dto";
import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";
import HumanAgentEntity from "../../../../domain/entities/human_agent.entity";

const getAudioResultsApiImpl = async (_: {
    jobId: string, onCallBack?: (progress: number, message: string) => void, humanAgent?: HumanAgentEntity,
}): Promise<Either<ErrorEntity, QAResultEntity>> => {
    // const status = ["CREATED", "PROCESSING", "COMPLETED"];
    try {
        _.onCallBack?.(0, KeyWordLocalization.CheckAudioWithQuestionsUseCaseCreatingPetiton);
        const getAudioResults = async (jobId: string): Promise<QAResultEntity | string> => {
            const relativeUrl = "/job/" + jobId;
            const response = await di.get<HostApi>(HostApiName).get(relativeUrl, { contentType: "application/json" });
            if (response.job_status === "COMPLETED") {
                const re = QAResultDto.fromJSON(response);
                if (re.humanAgent == null) re.humanAgent = _.humanAgent;
                return re;
            } else return response.job_status;
        };

        //call every 5 seconds until get result type qa
        let result = await getAudioResults(_.jobId);
        let timeToWait = 5;
        while (typeof result === "string") {
            await new Promise((resolve) => setTimeout(resolve, timeToWait * 1000));
            result = await getAudioResults(_.jobId);
            console.log("result", result);
            if (result === "NOT_RATED") {
                return left({ code: KeyWordLocalization.CheckAudioWithQuestionsUseCaseErrorNotRated });
            }
            else if (result === "FAILED") {
                return left({ code: KeyWordLocalization.CheckAudioWithQuestionsUseCaseErrorProcessingQuestions });
            } else if (result === "CREATED") {
                _.onCallBack?.(10, KeyWordLocalization.CheckAudioWithQuestionsUseCaseCreatingPetiton);
            } else if (result === "PROCESSING") {
                timeToWait = 10;
                _.onCallBack?.(50, KeyWordLocalization.CheckAudioWithQuestionsUseCaseProcessingPetiton);
            }
        }
        return right(result as QAResultEntity);

    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getAudioResultsApiImpl;